(function () {
  'use strict';

  var namespace = window.SIOKIUU_POWER_PLANNER = window.SIOKIUU_POWER_PLANNER || {};
  if (namespace.init) {
    namespace.init(document);
    return;
  }

  var iconPaths = {
    refrigerator: '<path d="M7 3h10v18H7z"/><path d="M7 11h10M10 7h.01M10 15h.01M7 20h10"/>',
    freezer: '<rect x="6" y="3" width="12" height="18" rx="1"/><path d="M6 9h12M10 6h.01M10 14h.01"/>',
    lightbulb: '<path d="M9 18h6M10 21h4M8.5 14.5A6 6 0 1 1 15.5 14.5c-.9.7-1.4 1.6-1.5 2.5h-4c-.1-.9-.6-1.8-1.5-2.5Z"/>',
    router: '<rect x="4" y="12" width="16" height="6" rx="1"/><path d="M8 9a6 6 0 0 1 8 0M10 6a3 3 0 0 1 4 0M8 15h.01M12 15h.01M16 15h.01"/>',
    medical: '<rect x="5" y="4" width="14" height="16" rx="2"/><path d="M12 8v8M8 12h8"/>',
    laptop: '<rect x="5" y="5" width="14" height="10" rx="1"/><path d="M3 19h18"/>',
    television: '<rect x="4" y="5" width="16" height="12" rx="1"/><path d="m9 21 3-4 3 4M9 3l3 2 3-2"/>',
    phone: '<rect x="8" y="3" width="8" height="18" rx="1"/><path d="M11 18h2"/>',
    pump: '<path d="M5 19V9h10v10H5Z"/><path d="M8 9V5h7l3 3M15 13h4v6h-4M8 13h4"/>',
    microwave: '<rect x="3" y="6" width="18" height="12" rx="1"/><path d="M6 9h8v6H6zM17 10h.01M17 14h.01"/>',
    coffee: '<path d="M7 4h9l1 15H6L7 4Z"/><path d="M9 4V2h5v2M17 8h2a2 2 0 0 1 0 4h-2M9 8h5"/>',
    heater: '<rect x="6" y="4" width="12" height="16" rx="1"/><path d="M9 8h6M9 12h6M9 16h6"/>',
    dishwasher: '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M5 8h14M9 5h.01M12 5h.01M8 12h8v6H8z"/>',
    'air-conditioner': '<rect x="4" y="6" width="16" height="12" rx="1"/><path d="M7 10h10M8 14h.01M11 14h.01M14 14h.01M17 14h.01"/>',
    battery: '<rect x="5" y="7" width="14" height="10" rx="1"/><path d="M19 10h2v4h-2M8 12h5M10.5 9.5v5"/>',
    drill: '<path d="M4 9h10l3 3-3 3H9v4H6v-4H4V9Z"/><path d="M14 9V6h4v3M17 12h3"/>',
    saw: '<path d="M5 8h10l4 4-4 4H5z"/><path d="M8 12h.01M11 12h.01M14 12h.01M4 18h16"/>',
    grinder: '<circle cx="10" cy="13" r="5"/><path d="m14 9 5-5M15 15l4 4M6 13h8"/>',
    vacuum: '<path d="M6 18V9h8l3 4v5H6Z"/><path d="M17 13h2v5h-2M9 9V5h5"/>',
    compressor: '<rect x="5" y="9" width="12" height="8" rx="1"/><circle cx="8" cy="19" r="1"/><circle cx="15" cy="19" r="1"/><path d="M9 9V5h4v4M17 12h2"/>'
  };

  function numberValue(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function formatWatts(value) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.max(0, Math.round(numberValue(value, 0)))) + 'W';
  }

  function element(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function iconMarkup(iconName) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (iconPaths[iconName] || iconPaths.refrigerator) + '</svg>';
  }

  function meterTone(ratio) {
    if (ratio > 1) return 'danger';
    if (ratio > .75) return 'warning';
    return 'success';
  }

  function getRoots(container) {
    var roots = [];
    if (container && container.matches && container.matches('[data-generator-power-planner]')) roots.push(container);
    if (container && container.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(container.querySelectorAll('[data-generator-power-planner]')));
    return roots;
  }

  function initPlanner(root) {
    if (root.dataset.plannerReady === 'true') return;
    var data = window.SIOKIUU_POWER_DATA;
    var core = window.SiokiuuGeneratorSizeCore;
    var handle = root.dataset.productHandle || '';
    if (!data || !core || !data.generators[handle] || !data.productProfiles[handle]) return;
    root.dataset.plannerReady = 'true';

    var generator = data.generators[handle];
    var profile = data.productProfiles[handle];
    var visibleCount = Math.max(1, numberValue(root.dataset.visibleCount, 8));
    var showRuntime = root.dataset.showRuntime === 'true';
    var showPlanningNotice = root.dataset.showPlanningNotice === 'true';
    var showFinderLink = root.dataset.showFinderLink === 'true';
    var allowCustomDevice = root.dataset.allowCustomDevice === 'true';
    var appliances = data.appliances;
    var selections = new Map();
    var nameplateDrafts = new Map();
    var expanded = false;

    var heading = root.querySelector('[data-planner-heading]');
    var subheading = root.querySelector('[data-planner-subheading]');
    var helper = root.querySelector('[data-planner-helper]');
    var grid = root.querySelector('[data-planner-grid]');
    var moreButton = root.querySelector('[data-planner-more]');
    var selectionList = root.querySelector('[data-planner-selection]');
    var customOpen = root.querySelector('[data-planner-custom-open]');
    var customForm = root.querySelector('[data-planner-custom-form]');
    var customCancel = root.querySelector('[data-planner-custom-cancel]');
    var customError = root.querySelector('[data-planner-custom-error]');
    var finderLink = root.querySelector('[data-planner-finder-link]');
    var status = root.querySelector('[data-planner-status]');
    var statusCopy = root.querySelector('[data-planner-status-copy]');
    var runningValue = root.querySelector('[data-planner-running-value]');
    var startingValue = root.querySelector('[data-planner-starting-value]');
    var runningMeter = root.querySelector('[data-planner-running-meter]');
    var startingMeter = root.querySelector('[data-planner-starting-meter]');
    var runningFill = root.querySelector('[data-planner-running-fill]');
    var startingFill = root.querySelector('[data-planner-starting-fill]');
    var runningHeadroom = root.querySelector('[data-planner-running-headroom]');
    var startingHeadroom = root.querySelector('[data-planner-starting-headroom]');
    var capacity = root.querySelector('[data-planner-capacity]');
    var recommendation = root.querySelector('[data-planner-recommendation]');
    var capacityNotice = root.querySelector('[data-planner-capacity-notice]');
    var runtime = root.querySelector('[data-planner-runtime]');
    var runtimeList = root.querySelector('[data-planner-runtime-list]');
    var outletNote = root.querySelector('[data-planner-outlet-note]');

    function applianceLabel(appliance) {
      return profile.labels[appliance.id] || (appliance.nameplateRequired ? 'Check Nameplate' : 'Good Fit');
    }

    function selectedItems() {
      return Array.from(selections.values()).map(function (selection) {
        return { id: selection.id, name: selection.name, runningWatts: selection.runningWatts, startingWatts: selection.startingWatts, quantity: selection.quantity };
      });
    }

    function setSelection(appliance, watts) {
      selections.set(appliance.id, {
        id: appliance.id,
        name: appliance.name,
        runningWatts: watts && watts.runningWatts != null ? watts.runningWatts : appliance.runningWatts,
        startingWatts: watts && watts.startingWatts != null ? watts.startingWatts : appliance.startingWatts,
        quantity: selections.has(appliance.id) ? selections.get(appliance.id).quantity : 1,
        isCustom: false
      });
    }

    function validNameplateDraft(draft) {
      return draft && Number.isFinite(draft.runningWatts) && draft.runningWatts > 0 && Number.isFinite(draft.startingWatts) && draft.startingWatts >= draft.runningWatts;
    }

    function createNameplateFields(appliance) {
      var draft = nameplateDrafts.get(appliance.id) || { runningWatts: '', startingWatts: '' };
      var fields = element('div', 'siokiuu-power-planner__nameplate-fields');
      [['runningWatts', 'Running Watts'], ['startingWatts', 'Starting Watts']].forEach(function (field) {
        var label = element('label', '', field[1]);
        var input = element('input');
        input.type = 'number';
        input.min = '1';
        input.inputMode = 'numeric';
        input.value = draft[field[0]] === '' ? '' : String(draft[field[0]]);
        input.dataset.plannerNameplateField = field[0];
        input.dataset.applianceId = appliance.id;
        input.setAttribute('aria-label', appliance.name + ' ' + field[1]);
        label.appendChild(input);
        fields.appendChild(label);
      });
      return fields;
    }

    function createCard(appliance) {
      var card = element('article', 'siokiuu-power-planner__appliance');
      var icon = element('span', 'siokiuu-power-planner__icon');
      icon.innerHTML = iconMarkup(appliance.icon);
      card.appendChild(icon);
      card.appendChild(element('strong', 'siokiuu-power-planner__appliance-name', appliance.name));
      if (appliance.nameplateRequired) {
        card.appendChild(element('span', 'siokiuu-power-planner__nameplate', 'Check device nameplate'));
      } else {
        card.appendChild(element('span', 'siokiuu-power-planner__watts', formatWatts(appliance.runningWatts) + ' Running'));
        card.appendChild(element('span', 'siokiuu-power-planner__watts', formatWatts(appliance.startingWatts) + ' Starting'));
      }
      card.appendChild(element('span', 'siokiuu-power-planner__tag', applianceLabel(appliance)));
      return card;
    }

    function renderAppliances() {
      if (!grid) return;
      grid.textContent = '';
      profile.defaultApplianceIds.slice(0, 9).forEach(function (id) {
        if (appliances[id]) grid.appendChild(createCard(appliances[id]));
      });
      if (moreButton) moreButton.hidden = true;
    }

    function createQuantityControl(selection) {
      var control = element('span', 'siokiuu-power-planner__quantity');
      [['minus', '−', 'Decrease ' + selection.name + ' quantity'], ['plus', '+', 'Increase ' + selection.name + ' quantity']].forEach(function (details) {
        var button = element('button', '', details[1]);
        button.type = 'button';
        button.dataset.plannerQuantity = details[0];
        button.dataset.applianceId = selection.id;
        button.setAttribute('aria-label', details[2]);
        control.appendChild(button);
        if (details[0] === 'minus') control.appendChild(element('output', '', String(selection.quantity)));
      });
      return control;
    }

    function renderSelection() {
      if (!selectionList) return;
      selectionList.textContent = '';
      var selected = selectedItems();
      if (!selected.length) {
        selectionList.appendChild(element('p', 'siokiuu-power-planner__selection-empty', 'Select appliances to begin.'));
        return;
      }
      selected.forEach(function (selection) {
        var row = element('div', 'siokiuu-power-planner__selection-row');
        var copy = element('div');
        copy.appendChild(element('strong', '', selection.name));
        copy.appendChild(element('small', '', formatWatts(selection.runningWatts) + ' Running · ' + formatWatts(selection.startingWatts) + ' Starting'));
        row.appendChild(copy);
        row.appendChild(createQuantityControl(selection));
        selectionList.appendChild(row);
      });
    }

    function calculateLoad() {
      var selected = selectedItems();
      if (!selected.length) return { runningWatts: 0, startingWatts: 0, largestSurge: 0 };
      var demand = core.calculateDemand(selected);
      return { runningWatts: numberValue(demand.runTotal, 0), startingWatts: numberValue(demand.peakNeeded, 0), largestSurge: numberValue(demand.largestSurgeWatts, 0) };
    }

    function classifyLoad(load) {
      if (!load.runningWatts && !load.startingWatts) return { title: '0% LOAD', message: 'Select appliances to begin.', tone: 'muted', ratio: 0, runningRatio: 0, startingRatio: 0 };
      var runningRatio = load.runningWatts / generator.planningRunningWatts;
      var startingRatio = load.startingWatts / generator.planningStartingWatts;
      var ratio = Math.max(runningRatio, startingRatio);
      if (ratio > 1) {
        var title = runningRatio > 1 && startingRatio > 1 ? 'RUNNING AND STARTUP LIMITS EXCEEDED' : (runningRatio > 1 ? 'RUNNING LOAD EXCEEDED' : 'STARTUP LIMIT EXCEEDED');
        return { title: title, message: 'Reduce simultaneous loads or choose a larger generator.', tone: 'danger', ratio: ratio, runningRatio: runningRatio, startingRatio: startingRatio };
      }
      if (ratio > .9) return { title: 'NEAR THE LIMIT', message: 'Reduce non-essential loads before starting a motor-driven appliance.', tone: 'warning', ratio: ratio, runningRatio: runningRatio, startingRatio: startingRatio };
      if (ratio > .75) return { title: 'FITS — MANAGE HIGH-DRAW LOADS', message: 'Leave extra headroom before starting a motor-driven appliance.', tone: 'warning', ratio: ratio, runningRatio: runningRatio, startingRatio: startingRatio };
      return { title: 'FITS COMFORTABLY', message: 'This load fits within the conservative planning capacity.', tone: 'success', ratio: ratio, runningRatio: runningRatio, startingRatio: startingRatio };
    }

    function recommendationFor(load) {
      if (!load.runningWatts || !load.startingWatts) return null;
      var candidates = Object.keys(data.generators).map(function (id) { return data.generators[id]; }).filter(function (candidate) {
        return candidate.handle !== generator.handle && candidate.planningRunningWatts >= load.runningWatts && candidate.planningStartingWatts >= load.startingWatts;
      });
      if (!candidates.length) return null;
      if (profile.context === 'jobsite') {
        var jobsiteCandidate = candidates.find(function (candidate) { return candidate.handle === '4000w-open-frame-generator'; });
        if (jobsiteCandidate) return jobsiteCandidate;
      }
      if (profile.context === 'rv') {
        var rvCandidate = candidates.find(function (candidate) { return candidate.hasTT30R; });
        if (rvCandidate) return rvCandidate;
      }
      if (profile.context === 'quiet-home') {
        var quietCandidates = candidates.filter(function (candidate) { return !candidate.isOpenFrame; });
        if (quietCandidates.length) candidates = quietCandidates;
      }
      candidates.sort(function (left, right) {
        return left.planningRunningWatts - right.planningRunningWatts || left.planningStartingWatts - right.planningStartingWatts;
      });
      return candidates[0];
    }

    function updateMeter(fill, label, value, capacityValue, ratio) {
      if (label) label.textContent = formatWatts(value) + ' / ' + formatWatts(capacityValue) + ' (' + Math.round(ratio * 100) + '%)';
      if (!fill) return;
      fill.style.width = Math.min(100, Math.max(0, ratio * 100)) + '%';
      fill.dataset.tone = meterTone(ratio);
    }

    function headroomText(label, capacityValue, loadValue) {
      var remaining = capacityValue - loadValue;
      return remaining >= 0 ? label + ': ' + formatWatts(remaining) : label + ': Over by ' + formatWatts(Math.abs(remaining));
    }

    function renderResult() {
      var load = calculateLoad();
      var state = classifyLoad(load);
      if (status) {
        status.textContent = state.title;
        status.dataset.tone = state.tone;
      }
      if (statusCopy) statusCopy.textContent = state.message;
      if (runningValue) runningValue.textContent = formatWatts(load.runningWatts);
      if (startingValue) startingValue.textContent = formatWatts(load.startingWatts);
      updateMeter(runningFill, runningMeter, load.runningWatts, generator.planningRunningWatts, state.runningRatio);
      updateMeter(startingFill, startingMeter, load.startingWatts, generator.planningStartingWatts, state.startingRatio);
      if (runningHeadroom) runningHeadroom.textContent = headroomText('Running headroom', generator.planningRunningWatts, load.runningWatts);
      if (startingHeadroom) startingHeadroom.textContent = headroomText('Starting headroom', generator.planningStartingWatts, load.startingWatts);
      if (capacity) capacity.innerHTML = '<strong>' + generator.model + ' planning capacity:</strong> ' + formatWatts(generator.planningRunningWatts) + ' running / ' + formatWatts(generator.planningStartingWatts) + ' starting. <br><strong>Published output:</strong> ' + formatWatts(generator.publishedRunningWatts) + ' running / ' + formatWatts(generator.publishedStartingWatts) + ' starting.';
      if (recommendation) {
        recommendation.textContent = '';
        if (state.ratio > 1) {
          var candidate = recommendationFor(load);
          if (candidate) {
            recommendation.appendChild(element('strong', '', 'Recommended model: '));
            var link = element('a', '', candidate.model);
            link.href = candidate.productUrl;
            recommendation.appendChild(link);
            recommendation.appendChild(document.createTextNode(' fits this conservative planning load.'));
          } else {
            recommendation.appendChild(element('strong', '', 'No Single Model Fits This Combination. '));
            recommendation.appendChild(document.createTextNode('Reduce simultaneous loads before operating.'));
          }
        }
      }
      if (capacityNotice) capacityNotice.hidden = !showPlanningNotice;
    }

    function renderRuntime() {
      if (runtime) runtime.hidden = !showRuntime;
      if (!showRuntime || !runtimeList) return;
      runtimeList.textContent = '';
      generator.runtime.forEach(function (reference) { runtimeList.appendChild(element('span', '', reference)); });
      if (outletNote) {
        outletNote.textContent = generator.outletNote || generator.noiseNote || '';
        outletNote.hidden = !outletNote.textContent;
      }
    }

    function render() {
      if (heading) heading.textContent = profile.title;
      if (subheading) subheading.textContent = profile.subtitle;
      if (helper) helper.textContent = profile.helper;
      if (customOpen) customOpen.hidden = !allowCustomDevice;
      if (finderLink) finderLink.hidden = !showFinderLink;
      renderAppliances();
      renderSelection();
      renderResult();
      renderRuntime();
    }

    function clearNameplate(applianceId) {
      nameplateDrafts.delete(applianceId);
      selections.delete(applianceId);
    }

    function toggleAppliance(applianceId) {
      var appliance = appliances[applianceId];
      if (!appliance) return;
      if (selections.has(applianceId) || nameplateDrafts.has(applianceId)) {
        clearNameplate(applianceId);
      } else if (appliance.nameplateRequired) {
        nameplateDrafts.set(applianceId, { runningWatts: '', startingWatts: '' });
      } else {
        setSelection(appliance);
      }
      render();
    }

    function updateQuantity(applianceId, direction) {
      var selection = selections.get(applianceId);
      if (!selection) return;
      var nextQuantity = selection.quantity + (direction === 'plus' ? 1 : -1);
      if (nextQuantity < 1) selections.delete(applianceId);
      else selection.quantity = Math.min(20, nextQuantity);
      render();
    }

    function updateNameplateField(input) {
      var applianceId = input.dataset.applianceId;
      var appliance = appliances[applianceId];
      if (!appliance) return;
      var draft = nameplateDrafts.get(applianceId) || { runningWatts: '', startingWatts: '' };
      draft[input.dataset.plannerNameplateField] = input.value === '' ? '' : numberValue(input.value, NaN);
      nameplateDrafts.set(applianceId, draft);
      if (validNameplateDraft(draft)) {
        setSelection(appliance, draft);
        nameplateDrafts.delete(applianceId);
      } else {
        selections.delete(applianceId);
      }
    }

    function customInputValue(name) {
      return customForm && customForm.elements[name] ? customForm.elements[name].value : '';
    }

    function addCustomDevice() {
      if (!customForm) return;
      var name = String(customInputValue('name') || '').trim();
      var runningWatts = numberValue(customInputValue('runningWatts'), NaN);
      var startingWatts = numberValue(customInputValue('startingWatts'), NaN);
      var quantity = numberValue(customInputValue('quantity'), NaN);
      var error = '';
      if (!name) error = 'Enter a device name.';
      else if (!Number.isFinite(runningWatts) || runningWatts <= 0) error = 'Running Watts must be greater than 0.';
      else if (!Number.isFinite(startingWatts) || startingWatts < runningWatts) error = 'Starting Watts cannot be lower than Running Watts.';
      else if (!Number.isFinite(quantity) || quantity < 1 || quantity > 20) error = 'Quantity must be between 1 and 20.';
      if (error) {
        if (customError) {
          customError.textContent = error;
          customError.hidden = false;
        }
        return;
      }
      var customId = 'custom-' + Date.now();
      selections.set(customId, { id: customId, name: name, runningWatts: Math.round(runningWatts), startingWatts: Math.round(startingWatts), quantity: Math.round(quantity), isCustom: true });
      customForm.reset();
      customForm.hidden = true;
      if (customError) {
        customError.textContent = '';
        customError.hidden = true;
      }
      render();
    }

    function saveForFinder() {
      var selected = selectedItems();
      if (!selected.length) return;
      try {
        localStorage.setItem(data.storageKey, JSON.stringify({ version: data.version, expiresAt: Date.now() + data.storageMaxAgeMs, appliances: selected }));
      } catch (error) {
      }
    }

    root.addEventListener('click', function (event) {
      var applianceButton = event.target.closest('[data-planner-appliance]');
      if (applianceButton && root.contains(applianceButton)) {
        toggleAppliance(applianceButton.dataset.plannerAppliance);
        return;
      }
      var quantityButton = event.target.closest('[data-planner-quantity]');
      if (quantityButton && root.contains(quantityButton)) {
        updateQuantity(quantityButton.dataset.applianceId, quantityButton.dataset.plannerQuantity);
        return;
      }
      if (event.target.closest('[data-planner-more]')) {
        expanded = !expanded;
        renderAppliances();
        return;
      }
      if (event.target.closest('[data-planner-custom-open]')) {
        if (customForm) customForm.hidden = false;
        if (customError) customError.hidden = true;
        var nameInput = customForm && customForm.elements.name;
        if (nameInput) nameInput.focus();
        return;
      }
      if (event.target.closest('[data-planner-custom-cancel]')) {
        if (customForm) {
          customForm.reset();
          customForm.hidden = true;
        }
        return;
      }
      if (event.target.closest('[data-planner-finder-link]')) saveForFinder();
    });

    root.addEventListener('input', function (event) {
      var input = event.target;
      if (!input.matches('[data-planner-nameplate-field]')) return;
      updateNameplateField(input);
    });

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('[data-planner-nameplate-field]')) return;
      updateNameplateField(input);
      render();
    });

    if (customForm) customForm.addEventListener('submit', function (event) {
      event.preventDefault();
      addCustomDevice();
    });

    render();
  }

  namespace.init = function (container) {
    getRoots(container || document).forEach(initPlanner);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { namespace.init(document); });
  else namespace.init(document);
  document.addEventListener('shopify:section:load', function (event) { namespace.init(event.target); });
})();
